function Slideshow_edit(element) {
    this.$element = $(element);
    
    this.selectors = {
		editToolbar: '.js-edit-toolbar',
	    grid: '.js-slideshow-grid',
	    slideshowWrapper: '.js-slideshow-wrapper',
		slideshowContainer: '.js-slideshow-container',
		toolbarGridButton: '.js-toolbar-grid',
		toolbarPlayButton: '.js-toolbar-play'
    };
	
	this.data = {
	    defaultView: 'default-view'
    };
    
    this.triggers = {
	    slideshowDestroy: 'i4-slideshow:destroy',
		slideshowInit: 'i4-slideshow:initSlider',
		toolbarRendered: 'i4-toolbar:rendered'
    };
    
    this.init = function() {
	    this.defaultView = this.$element.data(this.data.defaultView);
	    this.toolbarGridId = this.$element.data(this.data.toolbarGridId);
		this.toolbarPlayId = this.$element.data(this.data.toolbarGridId);
		
		this.$editToolbar = this.$element.find(this.selectors.editToolbar);
		this.$toolbarGridButton = $('<div>');
		this.$toolbarPlayButton = $('<div>');
	    this.$grid = this.$element.find(this.selectors.grid);
	    this.$slideshowWrapper = this.$element.find(this.selectors.slideshowWrapper);
		this.$slideshowContainer = this.$element.find(this.selectors.slideshowContainer);
		
		this.$editToolbar.on(this.triggers.toolbarRendered, this.toolbarRendered.bind(this));
    };
    
    this.sync = function() {
	    if (this.defaultView === 'slideshow') {
			this.showSlideshow();
		} else {
			this.showGrid();
		}
    };
    
    this.showGrid = function() {	    
	    this.$slideshowWrapper.trigger(this.triggers.slideshowDestroy);
		        
        this.$grid.show();
		this.$slideshowWrapper.hide();
		
		this.$toolbarPlayButton.show();
		this.$toolbarGridButton.hide();
	};
	
	this.showSlideshow = function() {
	   	
    	if (this.$grid && this.$grid.length) {
	    	
			// var $images_original = this.$grid.find("[id^='component_image_']");
			var $images_original = this.$grid.find(".c-image");
			console.log('images_original', $images_original);
	    					
			// reorder slides
	    	$images_original.each((function(i, item) {
		    	var $image_id = $(item).data('id');
		    	var $slide_image = this.$element.find('#image_minimal_'+$image_id);
		    	this.$slideshowContainer.append($slide_image);
	    	}).bind(this));
			
			this.$slideshowWrapper.trigger(this.triggers.slideshowInit);
			
			this.$slideshowWrapper.show();
			this.$grid.hide(); 		
		
			this.$toolbarPlayButton.hide();
			this.$toolbarGridButton.show();
			
		}		
	};

	this.toolbarRendered = function() {
		// console.log('toolbarrendered', this.defaultView);
	    this.$toolbarGridButton = this.$element.find(this.selectors.toolbarGridButton);
	    this.$toolbarPlayButton = this.$element.find(this.selectors.toolbarPlayButton);

		this.$toolbarGridButton.hide();
		this.$toolbarPlayButton.hide();

		if (this.defaultView === 'slideshow') {
			this.$toolbarGridButton.show();
		} else {
			this.$toolbarPlayButton.show();
		}
	
		this.$toolbarGridButton.on('click', this.showGrid.bind(this));
		this.$toolbarPlayButton.on('click', this.showSlideshow.bind(this));
	};
}
